import * as React from 'react';
import { AutoComplete, Input } from 'antd';
import { DefaultOptionType } from 'rc-select/lib/Select';
import { useState } from 'react';
import { isNil } from 'lodash';

interface SearchAutoCompleteProps {
	/**
	 * Autocomplete options that shows in a dropdown
	 */
	options: DefaultOptionType[];
	/**
	 * The placeholder of input
	 */
	placeholder: string;
	/**
	 * Current value of the search
	 */
	value: string;
	/**
	 * Called when invoking search
	 */
	onSearch: (e: any) => void;
	/**
	 * Called when changing the input value
	 */
	onChange: (e: any) => void;
	/**
	 * Is fetching data for autocomplete options
	 */
	isLoadingOptions?: boolean;
}

const SearchAutoComplete: React.FC<SearchAutoCompleteProps> = (props) => {
	const { placeholder, value, options, onSearch, onChange, isLoadingOptions } = props;
	const [dropDownOpen, setDropdownOpen] = useState(false);
  
	return (
		<AutoComplete 
			value={value} 
			style={{ width: '100%' }} 
			options={options} 
			filterOption={true} 
			open={dropDownOpen} 
			onChange={(v) => {
				setDropdownOpen(true);
				onChange(v);
			}}
			onSelect={(v) => {
				onSearch(v);
				setDropdownOpen(false);
			}}
			onFocus={() => setDropdownOpen(true)}
			onBlur={() => setDropdownOpen(false)}
		>
			<Input.Search size="middle" placeholder={placeholder} 
				loading={!isNil(isLoadingOptions) ? isLoadingOptions : false} 
				onSearch={(v) => {
					onSearch(v);
					setDropdownOpen(false);
				}}
			/>
		</AutoComplete>
	);
};

export default SearchAutoComplete;